import {absCenter, absCenterY, absFill, clearfix, colors} from '@xpertdox_js/xdstyle';

const fl = {float: 'left'}

const arrowBtn = {
  padding: '8px',
  fill: '#717b83',
  width: '35%',
  background: '#fcfefe',
  ...fl,
}

export default {
  clearfix: clearfix,
  half: {
    width: '50%',
    ...fl,
    padding: '10px',
    background: colors.offWhite,
  },
  container: {
    // position: 'fixed',
    // left: 0, right: 0,
    // top: 0, bottom: 0,
    // zIndex: 1000,
    // background: 'rgba(0,0,0,0.12)',
    width: '100%',
    // height: '100vh',
    position: 'relative',
    zIndex: 1000,
  },
  innerContainer: {
    // ...absCenter,
    transition: 'width .18s',
    // height: '450px',
    width: '100%',
    height: '100%',
    margin: '0 auto',
  },
  contentContainer: {
    background: '#fcfefe',
    // borderRadius: '2px',
    // padding: '8px 0px',
    // boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
    // marginBottom: '10px',
    width: '100%',
    height: '100%',
    padding: '8px',
  },
  title: {
    fontSize: '24px',
    margin: '0 0 6px',
    width: '60%',
    ...fl
  },
  textInput: {
    borderWidth: '.5px',
    borderRadius: '3px',
    borderStyle: 'solid',
    maxWidth: '100%',
    borderColor: 'rgba(0,0,0,0.26)',
    textInputFoc: {
      borderColor: 'rgba(0,0,0,0.35)'
    }
  },
  contactTableWrap: {
    background: '#fcfefe',
    boxShadow: '0 1px 14px rgba(0,0,0,0.2)',
    position: 'absolute',
    left: 0,top: 0,bottom: 0,right: 0,
    zindex: 1001,
  },
  headers: {
    position: 'absolute',
    left: 0, right: 0, top: 0, bottom: 'auto',
    width: 'auto',
    display: 'block',
    zIndex: 1001,
    boxShadow: '0 8px 6px -6px rgba(0,0,0,0.12)',
    overflowX: 'hidden',
  },
  heading: {
    display: 'block',
    textAlign: 'center',
    background: '#fcfefe',
    color: '#3c3e48',
    height: '100%',
    paddingTop: '7px',
    fontWeight: 'bold',
  },
  cellsWrap: {
    marginTop: '34px',
    marginBottom: '41px',
    position: 'relative',
    zIndex: 1000,
  },
  cellContainer: {
    background: '#fff',
  },
  contactCell: {
    width: '45%',
    ...fl,
    overflow: 'hidden',
    fontSize: '14px',
    borderRight: '1px solid rgba(0,0,0,0.18)',
    borderBottom: '1px solid rgba(0,0,0,0.18)',
    height: '34px',
    position: 'relative',
  },
  contactCellControl: {
    width: '10%'
  },
  cellContent: {
    ...absCenterY,
    left: 0,
    paddingLeft: '2px',
  },
  close: {
    ...absFill,
    display: 'block',
    width: '100%',
    background: 'none',
    fill: '#717b83',
    padding: 0,
  },
  closeHov: {
    fill: '#E62712'
  },
  closeSVG: {
    ...absCenter,
    width: '20px',
    display: 'block',
  },
  ctContainer: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  toolbar: {
    position: 'absolute',
    bottom: 0, left: 0, right: 0,
    top: 'auto',
    background: '#fcfefe',
    boxShadow: '0 -8px 6px -6px rgba(0,0,0,0.12)',
    zIndex: 1001,
    overflowX: 'hidden',
  },
  arrowSVG: {
    display: 'block',
    width: '25px',
  },
  arrowLeft: {
    ...arrowBtn,
    clear: 'left',
  },
  arrowRight: {
    ...arrowBtn,
    clear: 'right',
  },
  arrowHov: {
    fill: '#2C81D2',
  },
  pageCount: {
    width: '30%',
    fontSize: '12px',
    textAlign: 'center',
    padding: '11px 0',
    ...fl,
  },
  formContainer: {
    marginTop: '10px',
  }
}
